import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeAuth from 'GlobalStores/User/StoreAuth'
import storeUser from 'GlobalStores/User/StoreUser'
import HttpHelper from 'Services/HttpHelper'

const CreatePaymentData = (uuid, countryCode3alpha) => {

    const qs = []

    if (ServerEnv.ENV === 'DEV') {
        qs.push('isCalculateInQa=1')
    }

    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-value/feelGreatUfg/${StoreCountry.Country3()}${qs.length ? '?' + qs.join('&') : ''}`

    const data = {
        uuid: uuid,
        source_path: window.location.href
    }

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const CreatePaymentLambdaData = (uuid, countryCode3alpha) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/format/${StoreCountry.Country3()}/feelGreat/detail-hydra-v2/${uuid}`

    return axios.get(HttpHelper.Proxy({ originalUrl: url }), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const CreateMemberAndOrder = hydraData => {
    const url = `${ServerEnv.Hydra()}/orders`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const CreateOrder = (hydraData, token, Language, c) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`
    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const CreateOrderAndAccount = hydraData => {
    const url = `${ServerEnv.Hydra()}/orders`
    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const CreateLambdaOrder = (lambdaData, token, Language, c) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`
    return axios.post(HttpHelper.Proxy({ originalUrl: url }), lambdaData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
}

const CreateWorldPayOrder = (hydraData, token) => {
    const url = `${ServerEnv.Hydra()}/customers/me/orders`
    // test Zone
    // const url = `https://hydraqa.unicity.net/v5a-test/customers/me/orders`

    // hydraData['lines'] = {
    //     items: [
    //         {
    //             item: {
    //                 href: 'https://hydraqa.unicity.net/v5a-test/items?id.unicity=35571'
    //             },
    //             quantity: 1
    //         }
    //     ]
    // }
    // test Zone

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), hydraData, {
        headers: {
            'Content-Type': 'application/json',
            // Authorization: `Bearer `
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const CreateAutoship = (autoOrder, token) => {
    const url = `${ServerEnv.Hydra()}/customers/me/autoorders`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), autoOrder, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const PostSms = dataSms => {
    const smsApi = `${ServerEnv.MemberCalls2()}/sms-api/sms`

    axios
        .post(HttpHelper.Proxy({ originalUrl: smsApi }), dataSms, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .catch(error => console.error(error))
}

const UpdateLog = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-log`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const PostEmail = dataEmail => {
    const emailApi = `${ServerEnv.MemberCalls2()}/email-api/message`

    axios
        .post(HttpHelper.Proxy({ originalUrl: emailApi }), dataEmail, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .catch(error => console.error(error))
}

const CustomerLogin = (username, password, timeout = 0) => {
    let data = {
        type: 'base64',
        value: btoa(`${username}:${password}`),
        namespace: `${ServerEnv.Hydra()}/customers`
    }

    const url = `${ServerEnv.Hydra()}/loginTokens`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json',
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const GetPaymentDetail = (paymentId, baId) => {
    const data = {
        payment_id: paymentId,
        type: baId ? 'shop' : 'enroll',
        ba_id: baId || ''
    }
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/detail/hydra`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

const GetPaymentProxyDetail = gateway_ref_id => {
    const data = {
        gateway_ref_id: gateway_ref_id
    }
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/detail/proxy`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

const UpdateLogByOrder = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/hydra-log-by-order`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const GetOrderDetailByOrderNumber = orderNumber => {
    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/order/data?order_number=${orderNumber}`

    return axios.get(HttpHelper.Proxy({ originalUrl: url }))
}

const RequestWorldPayDDC = bin => {
    const url = `${ServerEnv.Hydra()}/ddc`
    // const url = `https://hydraqa.unicity.net/v5a-test/ddc`
    return axios.post(
        HttpHelper.Proxy({ originalUrl: url }),
        {
            bin
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'X-Application': `asia.ufg.${StoreCountry.Country2()}`
            }
        }
    )
}

const GetHydraOrderDetail = async (orderNunber, token) => {
    const url = `${ServerEnv.Hydra()}/orders?id.unicity=${orderNunber}`
    // const url = `https://hydraqa.unicity.net/v5a-test/orders?id.unicity=${orderNunber}`
    return axios.get(HttpHelper.Proxy({ originalUrl: url }), {
        headers: {
            // Authorization: `Bearer `
            Authorization: `Bearer ${token}`,
            'X-Application': `asia.ufg.${StoreCountry.Country2()}`
        }
    })
}

const UpdateLambdaAutoshipLog = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/proxy-log-autoship`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const CreatePaymentDataForHostedGateway = data => {
    const url = `${ServerEnv.MemberCalls2()}/hot/payment_router/proxy/insert/${StoreCountry.Country3()}`

    return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const GetQRDetail = id => {
    const url = `${ServerEnv.MemberCalls2()}/hot//payment_router/2c2p/qrPaymentStatus/${id}`

    return axios.get(HttpHelper.Proxy({ originalUrl: url }))
}

const CreateUuid = (data, countryCode3Alpha, isGIDexist = 0) => {
    let queryStrings = []

    if (storeAuth?.GetId()) {
        queryStrings.push(`baId=${storeAuth?.GetId()}`)
    }

    if (isGIDexist || isGIDexist === 0) {
        queryStrings.push(`isGIDexist=${isGIDexist}`)
    }

    if (ServerEnv.ENV === 'DEV') {
        queryStrings.push(`dev=1`)
    }

    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/${countryCode3Alpha}/feelGreatUfg/address${queryStrings.length ? '?' + queryStrings.join('&') : ''}`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data, {
        headers: {
            'Content-Type': 'application/json',
            'authorization-hydra': `Bearer ${storeAuth.GetToken()}`
        }
    })
}

const UpdatePurchaseType = (data, countryCode3Alpha, isGIDexist = 0) => {
    console.log('data1', data)

    let queryStrings = []

    if (storeAuth?.GetId()) {
        queryStrings.push(`baId=${storeAuth?.GetId()}`)
    }

    if (isGIDexist || isGIDexist === 0) {
        queryStrings.push(`isGIDexist=${isGIDexist}`)
    }

    if (ServerEnv.ENV === 'DEV') {
        queryStrings.push(`dev=1`)
    }

    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/${countryCode3Alpha}/feelGreatUfg/address${queryStrings.length ? '?' + queryStrings.join('&') : ''}`

    return axios.put(HttpHelper.Proxy({ originalUrl: url }), data)
}

const CreateAccountAndUuid = (data, countryCode3Alpha) => {
    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/${countryCode3Alpha}/feelGreatReferral/createAccount?emailDelay=1h`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

const CreateAccountOnly = (data, countryCode3Alpha) => {
    let queryString = '?emailDelay=1h&isValaidateUUID=1'
    if (ServerEnv.ENV === 'DEV') {
        queryString += '&dev=1'
    }

    const url = `${ServerEnv.MemberCalls2()}/hot/formatV2/${countryCode3Alpha}/feelGreatUfg/createAccount${queryString}`

    return axios.post(HttpHelper.Proxy({ originalUrl: url }), data)
}

export const PaymentAPIs = {
    CreatePaymentData,
    CreatePaymentLambdaData,
    CreateMemberAndOrder,
    CreateOrder,
    CreateLambdaOrder,
    PostSms,
    UpdateLog,
    PostEmail,
    CustomerLogin,
    GetPaymentDetail,
    GetPaymentProxyDetail,
    CreateAutoship,
    UpdateLogByOrder,
    GetOrderDetailByOrderNumber,
    CreateWorldPayOrder,
    RequestWorldPayDDC,
    GetHydraOrderDetail,
    UpdateLambdaAutoshipLog,
    CreatePaymentDataForHostedGateway,
    GetQRDetail,
    CreateUuid,
    CreateAccountAndUuid,
    CreateOrderAndAccount,
    UpdatePurchaseType,
    CreateAccountOnly
}
